import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  interval: null,
  now: null,
};

const timeSlice = createSlice({
  name: 'time',
  initialState,
  reducers: {
    timerTick(state, action) {
      state.now = action.payload.now;
    },
    timerStart(state, action) {
      state.interval = action.payload.interval;
      state.now = action.payload.now;
    },
    timerStop(state) {
      if (state.interval) {
        clearInterval(state.interval);
      }
      state.interval = null;
    },
  },
});

export const { timerTick, timerStart, timerStop } = timeSlice.actions;

export const startTimer = () => (dispatch, getState) => {
  const currentInterval = getState().time && getState().time.interval;
  if (currentInterval) {
    clearInterval(currentInterval);
  }

  const interval = setInterval(() => dispatch(timerTick({ now: new Date() })), 1000);

  dispatch(
    timerStart({
      interval,
      now: new Date(),
    })
  );
};

export default timeSlice.reducer;


